import c from "../common";

export default {
  titletext: c.BBS_title.chn,
  Logout: c.Logout.chn,

  //Iontoolbar
  language: c.language.chn,
  name: c.name.chn,
  nickname: c.nickname.chn,
  phone: c.phone.chn,
  email: c.email.chn,

  //Button
  NewVendor: "新增商戶",
  ChangePassword: "變更密碼",

  //Tabs
  Vendor: c.vendor.chn,
  ApprovedMer: "已驗證商戶",
  NewApplication: "新商戶申請",
  AllEvent: "所有推廣活動",

  //tags
  hidden: c.hidden.chn,
  Unapprove: "有未審核資料",
  NA: "暫無",
  Product: "產品",
  ComingSoon: "即將推出",
};
